export interface IRegionalizedBanner {
    onlineBannerID: number;           // OBID
    name: string;                     // NAM
    couponID: number | null;          // CPNID
    isActive: boolean;                // ISACT
    showOnBrowser: boolean;           // SHBROW
    showOnApp: boolean;               // SHAPP
    sortingIndex: number;             // SIDX
    regionRuleType: RegionRuleType;   // RRTYP
    timeSensitive: boolean;           // TSENS
    images: IBannerImage[];           // IMGS
    regions?: IBannerRegion[];        // RGNS (with zone points for polygon checking)
    schedules?: IBannerSchedule[];    // SCHS
    couponNames?: { CULT: string; NAM: string; }[];  // CPNNAMS - Localized coupon names
}

export interface IBannerRegion {
    regionZoneID: number;             // RZID
    zoneName: string;                 // ZNAM
    points: IRegionZonePoint[];       // POINTS (polygon coordinates)
}

export interface IRegionZonePoint {
    pointIndex: number;               // PIDX
    latitude: number;                 // LAT
    longitude: number;                // LON
}

export interface IBannerImage {
    bannerImageID: number;
    onlineBannerID: number;
    sizeCode: BannerSizeCode;
    imagePath: string; 
}

export interface IBannerSchedule {
  bannerScheduleId: number;
  onlineBannerId: number;
  weekDayNo: number;
  isActive: boolean;
  startMinute: number;
  endMinute: number;
}

/**
 * Raw banner DTO from backend API
 */
export interface BannerDto {
    OBID: number;
    NAM: string;
    CPNID?: number | null;
    ISACT: boolean;
    SHBROW: boolean;
    SHAPP: boolean;
    SIDX: number;
    RRTYP: RegionRuleType;
    TSENS: boolean;
    IMGS?: string | BannerImageDto[] | null;
    SCHS?: string | BannerScheduleDto[] | null;
    RGNS?: string | BannerRegionDto[] | null;
    CPNNAMS?: string | { CULT: string; NAM: string; }[] | null; 
}

export interface BannerImageDto {
    BIID: number;
    OBID: number;
    SZCD: BannerSizeCode;
    IMGPTH: string;
}

export interface BannerScheduleDto {
    BSID: number;
    OBID: number;
    WKDAY: number;
    ISACT: boolean;
    SMIN: number;
    EMIN: number;
}

export interface BannerRegionDto {
    RZID: number;
    ZNAM: string;
    POINTS?: string | RegionZonePointDto[] | null;
}

export interface RegionZonePointDto {
    PIDX: number;
    LAT: number;
    LON: number;
}
export interface IStoreOnlineBannerGroup {
    name: string;
    storeIDs: number[]; // Stores that belong to this group
}

export enum BannerSizeCode {
    LARGE = 0,    // 1200px+
    MEDIUM = 1,  // 768px–1200px
    SMALL = 2   // ≤768px
}

export enum RegionRuleType {
    ALL = 0,        // Non-Regionalized: Show to everyone regardless of location
    EXCLUDE = 1,    // Non-Regionalized with Exceptions: Show everywhere except defined regions
    INCLUDE = 2     // Regionalized: Show only in defined regions
}
